import { request } from "@/interface/helper";

const str = "communityTopic";

export const communityTopic = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/topic/list" }),
    add: data => request({ data, method: "post", url: "/community/topic/add" }),
    detail: data => request({ data, method: "post", url: "/community/topic/detail" }),
    edit: data => request({ data, method: "post", url: "/community/topic/modify" })
  }
};
